import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import TermsPageUI from './TermsPageUI.js'

class TermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      terms: null,
      messageList: null
    }
  }

  render() {
    return (
      <TermsPageUI
        context={this.props.context}
        terms={this.state.terms}
        messageList = {this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getContent(context)
    this.getMessages(context)
    document.body.classList.add('sdp')
  }

  getContent(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/contents/terms_and_conditions/locale/${context.locale}`,
      cacheKey: CacheKeys.Contents('tnc', context.locale),
      callback: this.getContentCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getContentCallback = (response) => {
    fetch(response.publicURL)
    .then((response) => {
      return response.text()
    })
    .then((text) => {
      console.log('<- GET', response.publicURL, /*text*/);
      this.setState({terms : text})
    })
  }

  getMessages(context) {
    let arr = [
      'c_terms',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_terms', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default TermsPageSF
